import React, { useEffect, useState } from "react";
import i18n from "@/i18n/config";

import Header from "@/components/header";
import Footer from "@/components/footer/Footer";
import AppRouter from "@/app/router/AppRouter";
import { AppContext } from "@/shared/context";
import { appHeaderTestProps } from "@/testData/testData";
import { usePageURL } from "@/shared/customHooks";

import "@/components/trustArc/trustArcConsent";
import { useLocation } from "react-router-dom";
import { upikPageRoutes } from "@/app/router/routes";
import { setDigitalData } from "@/services/setDigitalData";
import Loader from "@/components/loader";

const App = (): JSX.Element => {
  const { countryCode } = usePageURL();
  const [isCompanyErrorComponentMounted, isSetCompanyErrorComponentMounted] = useState(false)
  const [isBDTabClicked, setIsBDTabClicked] = useState(false);
  const [isEuBd, setIsEuBd] = useState(false);
	const [loginMenuOpen, setLoginMenuOpen] = useState(false);
  const location = useLocation();
  const shouldHideHeaderFooter = upikPageRoutes.includes(location.pathname);
  const [isDataLoad, setIsDataLoading] = useState(true);  

  useEffect(() => {
    if (countryCode) {
      i18n.changeLanguage(countryCode);
    }
    const isEuBd = ["de", "at", "ch", "hu", "pl"].includes(countryCode);
    // if(isEuBd) {
    //   TagManager.initialize({gtmId: EU_GTM_ID});
    // } else {
    //   TagManager.initialize({gtmId: GLOBAL_GTM_ID});
    // }
    setIsEuBd(isEuBd)
    setIsDataLoading(false)
    setDigitalData({gcpPageName: 'app', companyName: ''}); // Call setDigitalData here
  }, [countryCode]);

  const closeDropDown = () => {
    if (loginMenuOpen) setLoginMenuOpen(false)
  }

  const contextValue = {
    isUnitedStates: !isEuBd,
    isCompanyErrorComponentMounted, 
    isSetCompanyErrorComponentMounted,
    isBDTabClicked, 
    setIsBDTabClicked, 
    isEuBd
  }

  const headerProps = {
    ...appHeaderTestProps, loginMenuOpen, setLoginMenuOpen, countryCode
  }

  // Show loader while data is loading
  if(isDataLoad) return <Loader inProgress={true} />;

  return (
    <div id="app_page" onClick={closeDropDown}>
      <AppContext.Provider value={contextValue}>
         {!isCompanyErrorComponentMounted && !shouldHideHeaderFooter && (
          <Header {...headerProps} />
        )}
        <AppRouter />
        {!isCompanyErrorComponentMounted && !shouldHideHeaderFooter && (
          <Footer countryCode={countryCode} />
        )}
      </AppContext.Provider>
    </div>
  );
};

export default App;
